import React from "react";
import { Flex } from "@jsq/ds/core";
import SupportContentFooter from "apps/portal/Portal/common/SupportContentFooter";
import { type UnauthenticatedArenaObjectType } from "apps/portal/Portal/common/types";
import { Column } from "@jsq/ds/layouts";
import classNames from "classnames";
import { useIsXLScreenLogin } from "apps/login/LoginPage/hooks/useIsXLScreenLogin";
import styles from "./styles.scss";
import LogoContainer from "../../AccountActivation/LogoContainer";

export function imageIsSquareish(width: number, height: number) {
  const ratio = Math.min(width, height) / Math.max(width, height);
  return ratio >= 0.8;
}

type Props = {
  arena?: UnauthenticatedArenaObjectType;
  showArenaNameInFooter?: boolean;
  children: React.ReactNode;
  previewLogoWideUrl?: string;
  splitScreen?: boolean;
  showJSQLogo?: boolean;
};

const Layout: React.FunctionComponent<Props> = (props) => {
  const xl = useIsXLScreenLogin();
  const showSingleManagerName =
    props?.arena && !props.arena?.logoWideUrl && !props.arena?.headerLogoUrl;
  const logoWideUrl = props.showJSQLogo
    ? "/static/jsq_logo_header.svg"
    : props.previewLogoWideUrl ||
      props.arena?.logoWideUrl ||
      props.arena?.headerLogoUrl ||
      "/static/jsq_logo_header.svg";

  const logoUrl = showSingleManagerName ? null : logoWideUrl;

  return (
    <Flex
      flexDirection="row"
      justifyContent="center"
      flexGrow={1}
      className={classNames({
        [styles.Layout__columnContainer]: true,
        [styles.Layout__columnContainerSmToMd]: !xl,
        [styles.Layout__columnContainerLg]: xl,
      })}
    >
      <Column size="sm" className={styles.Layout__column}>
        <Flex flexDirection="column" alignItems="center" className={styles.Layout__flex}>
          <LogoContainer logoUrl={logoUrl} arenaName={props?.arena?.name} />
          <div
            className={classNames({
              [styles.Layout__cardWrapper]: true,
            })}
          >
            {props.children}
          </div>
        </Flex>
        <SupportContentFooter
          arenaName={props?.arena?.name}
          arenaContactEmail={props?.arena?.contactEmail}
          arenaContactPhone={props?.arena?.contactPhone}
          websiteUrl={props?.arena?.websiteUrl}
          showPoweredBy={false}
          showArenaName={
            props.showArenaNameInFooter !== undefined ? props.showArenaNameInFooter : true
          }
          hideCopyrightText={props?.arena?.hideCopyrightText ?? undefined}
        />
      </Column>
    </Flex>
  );
};

export default Layout;
